import React from 'react';
import { Input, Button, Header } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';
import NoFormInputs from './NoFormInputs';

const FormInputs = props => {
  const {
    isSubmitting,
    isSuccess,
    updateFormFields,
    submitForm,
    closeEmailCapture,
    type,
    headerText,
    subheaderText,
    description,
    descriptionTextColor,
    button,
    fields,
    textColor,
    bgColor,
    image,
    errors,
    darkCloseBtn,
  } = props;
  const displayCloseBtn = type === 'modal' && (!image || image.placement === 'left');

  let setBgColorStyle = {};
  if ((image && image.placement !== 'background') || !image) {
    setBgColorStyle = { backgroundColor: bgColor };
  }

  return (
    <div className="emailcapture-form" style={setBgColorStyle}>
      <div id="emailcapture-form-subheader-close-wrapper">
        {subheaderText && (
          <p className="emailcapture-form-subheader" style={{ color: textColor }}>
            {subheaderText}
          </p>
        )}
        {displayCloseBtn && (
          <Image
            as="a"
            id="closeEmailCapture"
            src={darkCloseBtn ? closebtnDarkImg : closebtnImg}
            onClick={closeEmailCapture}
          />
        )}
      </div>

      <Header className="emailcapture-form-header" style={{ color: textColor }}>
        {headerText}
      </Header>
      <p className="emailcapture-form-description" style={{ color: descriptionTextColor }}>
        {description}
      </p>

      {isSuccess && <NoFormInputs />}
      {!isSuccess && (
        <>
          {fields.map((field, key) => {
            const errorMsg = errors[field.key];
            return (
              <>
                <Input
                  key={field.label}
                  error={errorMsg}
                  className="emailcapture-form-input"
                  placeholder={field.label}
                  onChange={event => updateFormFields(field.key, event)}
                  value={field.value}
                />
                {errorMsg && (
                  <p
                    className="emailcapture-form-input-error"
                    style={{ color: descriptionTextColor }}
                  >
                    {errorMsg}
                  </p>
                )}
              </>
            );
          })}
          <Button
            primary={button.primary}
            loading={isSubmitting}
            onClick={submitForm}
            className="emailcapture-form-button"
            style={
              button.primary ? {} : { backgroundColor: button.bgColor, color: button.textColor }
            }
          >
            {button.label}
          </Button>
        </>
      )}
    </div>
  );
};

export default FormInputs;
